import { ChangeDetectorRef, Component, HostListener } from '@angular/core';
import { HeaderInfo, ThemeType } from './enums/emums';
import { Title } from '@angular/platform-browser';
import { ApidataService } from './services/apidata.service';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  // title = HeaderInfo.Title;
  // public static themeType = ThemeType.Old;
  // isMobile: any
  private previousParent: string | null = null;

  constructor(
    private router: Router
    // private titleService: Title, private cdr: ChangeDetectorRef, private apiData: ApidataService
  ) { }

  // ngOnInit(): void {
  //   this.loaderToggle(false);
  //   this.router.events.pipe(
  //     filter(event => event instanceof NavigationEnd)
  //   ).subscribe((event: NavigationEnd) => {
  //     const currentUrl = event.urlAfterRedirects;
  //     const currentParent = this.getParentPath(currentUrl);

  //     if (this.previousParent !== null && this.previousParent !== currentParent && (this.previousParent === 'user' || currentParent === 'user')) {
  //       // Reload page
  //       // window.location.href = currentUrl;
  //       this.loaderToggle(true);
  //       location.reload(); // or you can call window.location.href = currentUrl;
  //       this.loaderToggle(false);
  //     }

  //     this.previousParent = currentParent;
  //   });
  // }

  private getParentPath(url: string): string {
    const segments = url.split('/').filter(Boolean); // remove empty segments
    return segments.length > 1 ? segments[0] : ''; // '' if root
  }

  loaderToggle(flag) {
    if (flag) {
      const loader = document.querySelector('.pageLoaderDiv') as HTMLElement;
      if (loader) loader.style.display = 'flex';
    } else {
      const loader = document.querySelector('.pageLoaderDiv') as HTMLElement;
      if (loader) loader.style.display = 'none';
    }
  }
  // @HostListener('window:resize', ['$event'])
  // onResize(event) {
  //   // this.isMobile = event.innerwidth < 768
  //   // this.apiData.isMobileScreen$.next(this.isMobile);
  //   // localStorage.setItem('isMobile', this.isMobile)
  //   this.detectDevice();
  // }
  // detectDevice() {
  //   this.isMobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);
  //   this.apiData.isMobileScreen$.next(this.isMobile);
  //   localStorage.setItem('isMobile', this.isMobile)
  //   // this.updateView();
  // }
  // updateView() {
  //   if (!this.cdr['destroyed']) {
  //     this.cdr.detectChanges();
  //   }
  // }
}
